import type {LabelArchiveType as ServerLabelArchiveType} from '@github-ui/server-persisted-queries/types/RepositoryLabelIndexPageQuery'

export const CONSTS = {
  labelsPageSize: 30,
}

export type LabelArchiveType = Exclude<ServerLabelArchiveType, 'ALL'>

export const LABEL_ARCHIVE_TYPE = {
  ARCHIVED: 'ARCHIVED',
  UNARCHIVED: 'UNARCHIVED',
} as const satisfies Record<LabelArchiveType, LabelArchiveType>
